import { render, staticRenderFns } from "./upVip.vue?vue&type=template&id=9e0afd4c&"
import script from "./upVip.vue?vue&type=script&lang=js&"
export * from "./upVip.vue?vue&type=script&lang=js&"
import style0 from "./upVip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports